import {RatingsModel} from './ratings-model';

export class SelectionModelSizeCharacteristic {

  ratingsModel!: RatingsModel;
  modelCode!: string;
  sizeCode!: string;
  description!: string;
  width!: number;
  depth!: number;
  height!: number;
  nominalCfm!: number;
  dryWeight!: number;
  wetWeight!: number;
  costFactor!: number;

}
